module.exports = __webpack_public_path__ + "static/machine-metadata-8fbc875766b42fbcf66ce377763c4939.png";